import { useCommunityId } from '@/hooks/communities';
import { useNearbySchools, useUnit } from '@/hooks/units';
import PropertyDetailsPage from '@/pages/PropertyDetailsPage';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

const searchSchema = z.object({
  unitId: z.number().min(1),
});

export const Route = createFileRoute('/_layout/units')({
  component: PropertyDetailsPage,
  validateSearch: zodValidator(searchSchema),
  loaderDeps: ({ search }) => search,
  loader: async ({ context: { queryClient }, deps: { unitId } }) => {
    const data = await useCommunityId.ensureQueryData(queryClient);
    if (data?.communityId) {
      await useUnit.ensureQueryData(queryClient, [data.communityId, unitId]);
      await useNearbySchools
        .ensureQueryData(queryClient, [data.communityId, unitId])
        .catch(() => {});
    }
  },
});
